import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Perfil de Google',
  sections: {
    current_profile: {
      [mode_view]: 'Perfil conectado',
      [mode_edit]: 'Cambiar perfil conectado',
    },
  },
  form: {
    google_places_id: {
      label: 'Nombre en Google Maps',
    },
    address: {
      label: 'Dirección',
    },
    rating: {
      label: 'Valoración',
    },
    opening_hours: {
      label: 'Horario de apertura',
    },
    phone_number: {
      label: 'Número de teléfono',
    },
    pictures: {
      label: 'Imágenes',
    },
  },
  labels: {
    no_place_connected: 'Este restaurante no tiene ningún perfil de Google conectado',
    fields_to_sync: 'Información a sincronizar desde {{name}}',
  },
  buttons: {
    save: 'Guardar',
    change: 'Cambiar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
